<template>
  <v-list three-line>
    <template v-if="title">
    <v-list-item>
      <h3 class="mx-auto">{{ title }}</h3>
    </v-list-item>
    <v-divider />
    </template>
    <template v-for="list in lists">
    <v-list-item
      :key="'list' + list.id"
      :to="{name: 'List', params: {id: list.id}}"
    >
      <v-list-item-content>
        <v-list-item-title>{{ list.title }}</v-list-item-title>
        <v-list-item-subtitle>
          {{ utils.shorten(list.description, 400) }}
        </v-list-item-subtitle>
        <v-list-item-subtitle class="mt-3">
          Last updated {{ $moment(list.date).fromNow() }}
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-btn
          v-if="showOwners"
          text
          :to="{name: 'User', params: {id: list.user_id}}"
        >{{ list.username }}</v-btn>
        <slot name="extra-actions" :list="list" />
      </v-list-item-action>
    </v-list-item>
    <v-divider :key="'listdiv' + list.id" />
    </template>
    <v-list-item>
      <slot name="footer" />
    </v-list-item>
  </v-list>
</template>

<script>
import utils from "@/utils/utils"

export default {
  name: "ListList",
  props: {
    lists: {
      type: Array,
      required: true,
    },
    showOwners: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    utils() {
      return utils
    },
  },
}
</script>
